import React, { Component } from "react";
import CreatePerson from "../../../components/CreatePerson/CreatePerson";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CreatePersonForm
Description : Componente que invoca al componente CreatePerson, para creación de empleados.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente CreatePerson
================================================================================ */
class CreatePersonForm extends Component{
    render(){
        return(
            <CreatePerson/>  
        )   
    }
}

export default CreatePersonForm;